import InputMobile from '@/components/ui/inputFormik/input-mobile';
import { forgetSendOtpMobile } from '@/services/auth';
import { loginMobileValidation } from '@/utils/validation/auth';
import { Form, Formik } from 'formik';
import { toast } from 'sonner';
import AuthStatment from '../auth-statment';
import { useTurnstile } from 'react-turnstile';
import TurnstileRecaptcha from '@/components/turnstile/TurnstileRecaptcha';

const ForgotMobile = ({ setAuth, t, onVerifyOtpValue }) => {
  const turnstile = useTurnstile();
  const handleSubmit = async (
    { mobile, recaptchaToken },
    { setSubmitting, setFieldValue }
  ) => {
    const mobileNumber = `00966${mobile.slice(1)}`;
    const res = await forgetSendOtpMobile(mobileNumber, recaptchaToken);
    if (!res?.data || res?.error?.success === 'false') {
      toast.error(t(res?.error?.error.replace('.', '')));
      turnstile.reset();
      setFieldValue('recaptchaToken', '');
    } else {
      toast.success(t('OTP sent to your mobile number'));
      onVerifyOtpValue({ mobileNumber });
      setAuth('otp');
    }
    setSubmitting(false);
  };
  return (
    <>
      <AuthStatment
        title={t('Enter your Phone Number')}
        description={t(
          'and we will send you a verification code to your mobile number'
        )}
      />
      <Formik
        onSubmit={handleSubmit}
        validationSchema={loginMobileValidation(t)}
        initialValues={{ mobile: '', recaptchaToken: '' }}
      >
        {({ isSubmitting, setFieldValue }) => (
          <Form className='flex flex-col gap-2 px-2 pb-4 lg:gap-4 lg:px-8'>
            <InputMobile id='mobile' name='mobile' title={t('Phone Number')} />

            <TurnstileRecaptcha
              action='forgot-mobile'
              className='flex items-center justify-center p-2'
              onVerify={(value) => {
                setFieldValue('recaptchaToken', value);
              }}
            />
            <button
              type='submit'
              className='flex h-10 w-full cursor-pointer items-center justify-center gap-3 rounded-lg bg-red-600 py-1 font-bold text-white hover:bg-red-600/70 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-red-600 max-lg:text-sm max-sm:h-9 lg:py-1.5'
              disabled={isSubmitting}
            >
              {isSubmitting && (
                <span className='border-primary-500 size-4 animate-spin rounded-full border-t border-r py-1 max-lg:size-2' />
              )}
              {t('Send Code')}
            </button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ForgotMobile;
